import { render, staticRenderFns } from "./LoginFormPasswordStep.vue?vue&type=template&id=885cb9a0"
import script from "./LoginFormPasswordStep.vue?vue&type=script&lang=js"
export * from "./LoginFormPasswordStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports